module.exports = "/wp-content/themes/onnit/script/cart/dist/o6SteelMace-6e9c32a8.jpg";